<template>
  <li v-if="data" class="my-purchase-cell" :class="(isShowPackageList ? 'my-purchase-list-open ' : ' ') + (isDeleted ? 'my-purchase-end' : '')">
    <div class="my-purchase-top">
      <div class="con-img package-con-img">
        <div class="img-wrap">
          <a @click.prevent="moveUrl(data.contentid)" href="#">
            <div class="picture-area">
              <WebpImage :imageInfo="{imageUrl: data.image, width: 185,height: 278, alt: data.title, className: 'thumb-img'}" />
            </div>
            <age-limits :targetAge="+data.targetage" :contentType="data.contenttype"/>
            <div :class="adultDimClass"></div>
          </a>
        </div>
      </div>
      <div v-if="isEditMode" class="my-purchase-check check-style">
        <input type="checkbox" @click="checkedPackage(data.paymentid)" class="selectedClass check-blue-dark" :id="index" :value="data.paymentid" :checked="isChecked">
        <label class="blind" :for="index"><span>선택</span></label>
      </div>
      <div class="con-text-wrap">
        <ul class="badge-list">
          <li class="left-top-area">
            <ul>
              <li>
                <span class="badge ui">{{data.contenttype === 'movie' ? '영화' : 'VOD'}}</span>
              </li>
              <li v-if="data.own === 'y'">
                <span class="badge ui">영구소장</span>
              </li>
              <li v-else-if="periodExpiration(data.enddatetime)">
                <span class="badge ui expire">기간만료</span>
              </li>
              <li v-else>
                <span class="badge ui">대여상품</span>
              </li>
            </ul>
          </li>
        </ul>
        <p class="con-tit">{{ data.title }}</p>
        <p class="con-text01">
          <span>구매일</span>
          <span class="title-dot"></span>
          <span>{{ data.startdatetime }}</span>
        </p>
        <p class="con-text01">
          <span>구매금액</span>
          <span class="title-dot"></span>
          <span>{{ data.price | setNumberCommas }}원</span>
        </p>
        <p class="con-text01">
          <span>만료일</span>
          <span class="title-dot"></span>
          <span>{{ data.enddatetime }}</span>
        </p>
        <button @click="clickAll()" class="my-purchase-btn"><span>{{isShowPackageList ? '닫기' : '전체보기'}}</span></button>
      </div>
    </div>

    <!-- 전체보기시 나오는 영화섹션 -->
    <div class="my-purchase-slide">
      <div :id="'package-container' + index" class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="page in pageNum" :key="page" class="swiper-slide">
            <div v-for="index in pageDataNum(page)" :key="index" class="vod-img thumb-movie">
              <a @click.prevent="moveUrl(pageData(page, index).movieid)" href="#">
                <div class="con-img">
                  <div class="picture-area">
                    <WebpImage :imageInfo="{imageUrl: pageData(page, index).image, width: 240, height: 360, alt: data.title, className: 'thumb-img'}" />
                  </div>
                  <age-limits :targetAge="+pageData(page, index).targetage" :contentType="data.contenttype"/>
                  <!--<icons-movie :icons="pageData(page, index).marks"/>-->
                  <div :class="adultDimAllClass(pageData(page, index))"></div>
                </div>
                <span class="con-text-wrap">
                  <p class="con-tit">{{pageData(page, index).title}}</p>
                </span>
              </a>
            </div>
          </div>
        </div>
        <div v-if="isReady" class="my-purchase-pager">
          <button :id="'swiper-button-prev' + index" class="swiper-button-prev"></button>
          <div :id="'swiper-pagination' + index" class="swiper-pagination"></div>
          <button :id="'swiper-button-next' + index" class="swiper-button-next"></button>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import Swiper from '@/mixins/swiper'
import AgeLimits from '@/components/model/AgeLimits'
import { getPurchaseProductContents } from '@/common/utils/request'
import { addPostfixAndUrl, setNumberCommas } from '@/common/utils/common'
import _ from 'lodash'
import cookie from '@/common/utils/cookie'
import { PATH_NAME_PLAYER_MOVIE } from '@/common/resources/router.const'
import WebpImage from '@/components/image/WebpImage'
export default {
  mixins: [
    Swiper
  ],
  components: {
    WebpImage,
    AgeLimits
  },
  filters: {
    addPostfixAndUrl,
    setNumberCommas
  },
  props: {
    data: {
      type: Object
    },
    index: {
      type: Number
    },
    isEditMode: {
      type: Boolean
    },
    setCheckFn: {
      type: Function
    }
  },
  data () {
    return {
      isShowPackageList: false,
      packageList: [],
      isDeleted: false,
      dataPerPage: 5,
      maxPage: 10,

      swiperOptions: {
        paginationClickable: true,
        centeredSlides: true,
        spaceBetween: 8,
        slidesPerView: 'auto',
        pagination: '#swiper-pagination' + this.index,
        nextButton: '#swiper-button-next' + this.index,
        prevButton: '#swiper-button-prev' + this.index
      },
      all: false,
      orderby: 'new',
      currentPage: 1,
      pagingCnt: 10,
      limit: 10,
      totalCount: 0,
      checked: false,
      placeholderImage: require('../../assets/images/common/img_default_thum_1.svg')
    }
  },
  computed: {
    pageNum () {
      if (!this.packageList) {
        return 0
      }
      let computedPage = Math.ceil(this.packageList.length / this.dataPerPage)
      return Math.min(computedPage, this.maxPage) === 0 ? 1 : Math.min(computedPage, this.maxPage)
    },
    isChecked () {
      return this.data.checked
    },
    adultDimClass () {
      if (cookie.isNotVerifiedAdultUser() && _.get(this.data, 'targetage', 0) >= 21) {
        return _.get(this.data, 'contenttype', '') === 'movie' ? 'movie-lock-21' : 'vod-lock-21'
      }
      return ''
    }
  },
  methods: {
    pageData (page, index) {
      const arrayIndex = ((page - 1) * this.dataPerPage) + (index - 1)
      return this.packageList[arrayIndex]
    },
    pageDataNum (page) {
      return Math.min(this.dataPerPage, this.packageList.length - ((page - 1) * this.dataPerPage))
    },
    // 전체보기 클릭 시 받아온 패키지 데이터가 없을 때 데이터를 받아온다.
    clickAll () {
      this.isShowPackageList = !this.isShowPackageList
      this.$events.$emit('showPackage', this.index)
      if (this.isShowPackageList) {
        this.setPackageData()
      }
    },
    periodExpiration (endTime, data) {
      if (new Date(endTime.replace(/-/g, '/')) > new Date()) return false
      if (data) return data
      return true
    },
    setPackageData () {
      getPurchaseProductContents({ productid: this.data.productid, contenttype: 'movie', offset: 0, limit: 50 }).then(({ data }) => {
        let packageList = data.map((packageItem) => {
          if (packageItem.type === 'movielist') {
            if (_.get(packageItem, 'list', []).length > this.dataPerPage) {
              this.swiperElement = '#package-container' + this.index
              this.isReady = true
            }
            return _.get(packageItem, 'list', [])
          }
        })
        this.packageList = packageList[0]
      })
    },
    checkedPackage (paymentId) {
      this.setCheckFn(paymentId)
    },
    moveUrl (id) {
      if (this.isEditMode) return
      this.$router.push({
        name: PATH_NAME_PLAYER_MOVIE,
        query: {
          movieid: id
        }
      })
    },
    selectedClass () {
      return this.checkCount > 0 ? 'selected-delete' : 'not-selecte'
    },
    adultDimAllClass (item) {
      const targetage = _.get(item, 'targetage', 0)
      return (!cookie.hasCredential() || cookie.isNotVerifiedAdultUser()) && targetage >= 21 ? 'movie-lock-21' : ''
    }
  },
  created () {
    this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
    this.$events.$on('showPackage', index => {
      if (this.index !== index) {
        this.isShowPackageList = false
      }
    })
  }
}
</script>
<style>
  /*.all-delete{*/
  /*  font-size: 16px;*/
  /*}*/
  /*.not-selecte{*/
  /*  color: #888 !important;*/
  /*}*/
</style>
